import colors from '@constants/colors';

function HotDefault() {
  return (
        <svg width="53" height="52" viewBox="0 0 53 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="26.75" cy="26" r="25.5" fill={colors.gray1} stroke="#0D0F11"/>
            <path
                d="M22.9124 38.925H24.6214H26.3038H28.0128C30.9122 38.925 33.2626 36.5746 33.2626 33.6752V32.3V28.3124C33.2626 27.5876 32.675 27 31.9502 27H22.8626H18.975C18.2502 27 17.6626 27.5876 17.6626 28.3124V32.3V33.6752C17.6626 36.5746 20.013 38.925 22.9124 38.925Z"
                stroke="#0D0F11" strokeWidth="2"/>
            <path
                d="M26.7626 22.025H19.6501C18.5524 22.025 17.6626 21.1351 17.6626 20.0375C17.6626 18.9398 18.5524 18.05 19.6501 18.05H30.6251C31.7228 18.05 32.6126 17.1601 32.6126 16.0625C32.6126 14.9648 31.7228 14.075 30.6251 14.075H23.5126"
                stroke="#0D0F11" strokeWidth="2" strokeLinecap="round"/>
            <path
                d="M34.0948 28.325H36.3628C37.5225 28.325 38.4627 29.2651 38.4627 30.4249V31.525C38.4627 32.6848 37.5225 33.625 36.3628 33.625H33.2627"
                stroke="#0D0F11" strokeWidth="2" strokeLinecap="round"/>
        </svg>
  );
}

export default HotDefault;
